<template><div v-show="isActive" :class="['tab-pane', isActive && 'active']" role="tabpanel"><slot></slot></div></template>
<script lang="ts">
import { computed, defineComponent, inject, onBeforeMount, onBeforeUnmount, onBeforeUpdate } from 'vue'
import { tabsContextKey } from './tabs-context'
export default defineComponent({
  name: 'BTab',
  props: { active: Boolean, titleLinkClass: { type: [String, Array, Object], default: '' } },
  setup(props, { slots }) {
    const tabs = inject(tabsContextKey, null)
    const id = Symbol('tab')
    const isActive = computed(() => tabs ? tabs.indexOf(id) === tabs.activeIndex() : props.active)
    const tab = () => ({
      title: slots.title,
      titleLinkClass: props.titleLinkClass
    })
    onBeforeMount(() => tabs?.register({ id, ...tab() }))
    onBeforeUpdate(() => tabs?.update(id, tab()))
    onBeforeUnmount(() => tabs?.unregister(id))
    return { isActive }
  }
})
</script>
